import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const LongSyntheticFutureSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.0205 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H32.7335" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M33 12.1017L17.0103 18.2076" stroke="#089981" strokeWidth="2"/>
        <path d="M1.0205 24.3136L17.0103 18.2076" stroke="#A40C0C" strokeWidth="2"/>
    </svg>
)

const LongSyntheticFuture: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {LongSyntheticFutureSvg(props)}
    </SvgIcon>
));
export default LongSyntheticFuture